export enum EnCardVariant {
  POSITIVE = 'positive',     // Green/success
  CAUTION = 'caution',       // Yellow/warning
  CRITICAL = 'critical',     // Red/error
  DISABLED = 'disabled',     // Grayed out (instead of "unavailable")
  BASE = 'base',             // Default style
}
